export default {"src":"/_next/static/media/nfd.1212b18d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};